import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";
import { get } from "react-hook-form";
const MyInput = ({
  title,
  name,
  register,
  trigger,
  errors,
  setValue,
  placeholder,
  required,
  min,
  max,
  disabled,
  inputPattern,
  pattern,
  patternMsg,
  type = "text",
}) => {
  const error = get(errors, name);
  const validationRules = {
    required: required
      ? {
          value: true,
          message: `${title || name} is required`,
        }
      : false,
    ...(pattern
      ? {
          pattern: {
            value: pattern,
            message: patternMsg,
          },
        }
      : {}),
    minLength: min
      ? {
          value: min,
          message: `${title || name} must be at least ${min} characters`,
        }
      : undefined,
    maxLength: max
      ? {
          value: max,
          message: `${title || name} must be at most ${max} characters`,
        }
      : undefined,
  };
  return (
    <div className="form-group my-2">
      <Label className="form-label overline-title text-soft" htmlFor={name}>
        {title}
        {required && title && <Required />}
      </Label>
      <div className="form-control-wrap">
        <input
          placeholder={placeholder}
          type={type}
          id={name}
          {...register(name, validationRules)}
          className={`form-control ${error ? "is-invalid" : ""}`}
          onChange={(e) => {
            let v = e.target.value;
            if (inputPattern) {
              v = v.replace(inputPattern, "");
            }
            setValue(name, v, { shouldValidate: true });
          }}
          disabled={disabled}
        />
        {error && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyInput;